module.exports = "<button (click)=\"login()\" class=\"btn btn-secondary\">\r\n  Login with Google</button>"


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = 1